import filterXss from 'xss';

import { hasLocalStorageAccess } from './pwa';

if (hasLocalStorageAccess()) {
  checkAndShowCookieInfo();
}

function checkAndShowCookieInfo() {
  const hasCookie = filterXss(localStorage.getItem('hasCookie'));

  if (!hasCookie) {
    const banner = document.querySelector('.cookie-notice-banner');
    if (banner) {
      banner.style = '';
      banner.removeAttribute('aria-hidden');
      const bannerButton = document.querySelector('.cookie-notice-banner button');
      bannerButton && bannerButton.addEventListener('click', () => {
        banner.style = 'display: none';
        banner.setAttribute('aria-hidden', 'true');
        localStorage.setItem('hasCookie', new Date());
      });
    }
  }
}
